import React, { useRef } from 'react';
import { Input } from '@/components/ui/input';
import { FormControl } from '@/components/ui/form';
import DynamicFieldSelector from './DynamicFieldSelector';

interface InputWithDynamicFieldsProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const InputWithDynamicFields: React.FC<InputWithDynamicFieldsProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  className,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFieldSelect = (field: string) => {
    if (inputRef.current) {
      const input = inputRef.current;
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;
      
      const newValue = value.substring(0, start) + field + value.substring(end);
      onChange(newValue);
      
      setTimeout(() => {
        input.focus();
        input.setSelectionRange(start + field.length, start + field.length);
      }, 0);
    } else {
      onChange(value + field);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex justify-end">
        <DynamicFieldSelector 
          onFieldSelect={handleFieldSelect} 
          disabled={disabled}
        />
      </div>
      <FormControl>
        <Input
          ref={inputRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={className}
        />
      </FormControl>
    </div>
  );
};

export default InputWithDynamicFields;
